// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// // Import images

// const TeacherSlider = () => {
//   const [personalInfo, setPersonalInfo] = useState([]);
//   const [profileImg, setProfileImg] = useState([]);
//   const [loading, setLoading] = useState(true);  // Handle loading state

//   const fetchTeacher = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/getTeachersData`);
//       setPersonalInfo(response.data.data.personalInfo);
//       setProfileImg(response.data.data.profileImg);
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTeacher();
//   }, []); 
//   return (
//     <div className="institute-slider-container event-slider">
//       {/* Show loader if data is still being fetched */}
//       {loading ? (
//         <p>Loading institutes...</p>
//       ) : profileImg.length > 0 ? (
//         <OwlCarousel
//           className="owl-theme"
//           loop
//           margin={15}
//           nav
//           autoplay
//           autoplayTimeout={3000}
//           responsive={{
//             0: { items: 1 },
//             600: { items: 2 },
//             1000: { items: 3 },
//           }}
//         >
//           {profileImg.map((profile, index) => (
//             <div className="item event-item" key={profile.id}>
//               <div className="institute-card event-img teacher-img">
//                 <img src={`${Image_Base_Url}${profile.profile_image_path}`} alt="Profile" />
//               </div>
//               <div className="course-meta tchr_info_wraper">
//               {personalInfo[index] && (         
//                 <h5 class="pb-2">{personalInfo[index]?.full_name || "Unknown Name"}</h5>
//               )}


//               <div class="event-meta">
//                 <span class="event-date"><i class="far fa-calendar-alt"></i>16 June, 2025</span>
//                 <span class="event-time"><i class="far fa-clock"></i>2:15 PM IST</span>
//               </div>
//               <div class="register_btn"><a href="#" class="theme-btn">Register Now</a></div>
//             </div>
//       </div>
//           ))}
//         </OwlCarousel>
//       ) : (
//         <p>No institutes available.</p>
//       )}
//     </div>
//   );
// };

// export default TeacherSlider;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL, Image_Base_Url } from "../constants/apiConstants";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const TeacherSlider = () => {
  const [personalInfo, setPersonalInfo] = useState([]);
  const [personalId, setPersonalId] = useState('');
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getTeachersData`);
        setPersonalInfo(response.data.data.personalInfo);
        setProfileImg(response.data.data.profileImg);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTeacher();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Validate form
  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Invalid phone number (10 digits required)";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async(e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted:", formData.name,formData.email,formData.phone,personalId);

      // return false
      try {
        const response = await axios.post(`${API_BASE_URL}/savelearnBestTeacherEnquaryData`, null, {
          params: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            teacher_id: personalId
          }
        });
    
        console.log(response.data);
        alert("Registered successfully!");
      setShowModal(false);
      setFormData({ name: "", email: "", phone: "" }); 
      } catch (error) {
        console.error("Error:", error);
        setShowModal(false);
      }
      // Reset form
    }
  };

  console.log("personal information",personalInfo,personalId)
  return (
    <div className="institute-slider-container event-slider">
      {loading ? (
        <p>Loading institutes...</p>
      ) : profileImg.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {profileImg.map((profile, index) => (
            <div className="item event-item" key={profile.id}>
              <div className="institute-card event-img teacher-img">
                <img
                  src={`${Image_Base_Url}${profile.profile_image_path}`}
                  alt="Profile"
                />
              </div>
              <div className="course-meta tchr_info_wraper">
                {personalInfo[index] && (
                  <h5 className="pb-2">
                    {personalInfo[index]?.full_name || "Unknown Name"}
                  </h5>
                )}
                <div className="event-meta">
                  <span className="event-date">
                    <i className="far fa-calendar-alt"></i>16 June, 2025
                  </span>
                  <span className="event-time">
                    <i className="far fa-clock"></i>2:15 PM IST
                  </span>
                </div>
                <div className="register_btn">
                  <button
                    className="theme-btn"
                    onClick={() => {setShowModal(true),setPersonalId(personalInfo[index]?.id)}}
                  >
                    Register Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <p>Coming soon.</p>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay1">
          <div className="modal-content1">
            <span className="close-btn" onClick={() => setShowModal(false)}>
              &times;
            </span>
            <h3>Register Now</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                {errors.name && <p className="error">{errors.name}</p>}
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>

              <button type="submit" className="theme-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Internal CSS */}
      <style>{`
        .modal-overlay1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content1 {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  width: 350px;
  max-width: 90%; /* Ensures responsiveness */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.close-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 20px;
  cursor: pointer;
}

        .form-group {
          margin-bottom: 15px;
          text-align: left;
        }
        .form-group label {
          display: block;
          font-weight: bold;
        }
        .form-group input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 5px;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
        .submit-btn {
          background: #007bff;
          color: white;
          padding: 10px;
          border: none;
          border-radius: 5px;
          width: 100%;
          cursor: pointer;
        }
        .submit-btn:hover {
          background: #0056b3;
        }
      `}</style>
    </div>
  );
};

export default TeacherSlider;
